import { gql } from 'apollo-boost'

import { TASK_VIEW_FIELDS } from '../fragments/task-view-fields'

const REOPEN_MENU_DEFINITION_TASK = gql`
  ${TASK_VIEW_FIELDS}
  mutation reopenMenuDefinitionTask($id: ID!) {
    reopenMenuDefinitionTask(id: $id) {
      id
      modifiedDate
      reopenedDate
      assignedTo {
        id
        name
      }
      currentViewType
      views {
        ...TaskViewFields
      }
    }
  }
`

export default REOPEN_MENU_DEFINITION_TASK
